<div class="no-data-card" [class.no-data-card--extra-top]="hasLongCopy">
  <div class="empty-state">
    <div class="icon-container" aria-hidden="true">
      <i-feather name="file-minus" class="empty-state-icon"></i-feather>
    </div>
    <h2 class="empty-state-title">
      {{ title || (titleKey ? (titleKey | translate) : ('ADCustomerCustomize.nodata' | translate)) }}
    </h2>
    <p class="empty-state-desc">
      {{ subtitle || (subtitleKey ? (subtitleKey | translate) : ('ADCustomerCustomize.nodata' | translate)) }}
    </p>
  </div>
</div>
